import { SystemStyleObject } from '@chakra-ui/react';

export const styles: Record<string, SystemStyleObject> = {
	headerGradient: {
		w: '100%',
		h: '80px',
		background: 'gradients.header',
		backgroundSize: '100%, ',
		backgroundPosition: 'right',
	},
	headerImage: {
		w: '100%',
		h: '80px',
		backgroundImage: "url('/images/header-back.svg')",
		backgroundSize: 'cover',
		position: 'absolute',
		backgroundPosition: 'center',
	},
	containerTitles: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		h: '80px',
		color: 'neutral.0',
		maxWidth: 'maxWidth.content',
		mx: 'auto',
	},
	textSide: {
		color: 'primary.200',
		fontFamily: 'heading',
		fontWeight: 'light',
		mb: '20px',
		_hover: { color: 'neutral.0', cursor: 'pointer' },
	},
	textFooter: {
		color: 'primary.250',
		fontFamily: 'heading',
		mb: '20px',
		fontSize: 'lg',
		fontWeight: 'bold',
	},
	titleSide: {
		color: 'primary.200',
		fontSize: '4xl',
		fontFamily: 'heading',
		fontWeight: 'light',
		mb: '20px',
		_hover: { color: 'neutral.0', cursor: 'pointer' },
	},
};
